import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { ILPCourseDescriptionData } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';

import s from './CourseDescription.scss';

interface ICourseDescriptionProps {
	data: ILPCourseDescriptionData;
}

export function CourseDescription({
	data,
}: ICourseDescriptionProps): JSX.Element {
	useStyles(s);
	const { title, description } = data;
	return (
		<section className="lp-course-description">
			<div className="lp-course-description__container">
				<h3 className="lp-course-description__title">{title}</h3>
				<p className="lp-course-description__description">
					{description}
				</p>
			</div>
		</section>
	);
}
